import { Alert, Button, ListGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { Input } from "reactstrap";

import { FETCH_SETTINGS } from "../../graphql/queries/management";
import {
  ACTIVATE_CRONJOB,
  GENERATE_NEW_CODE,
  OPEN_BUG,
} from "../../graphql/mutations/management";
import IconButton from "../../components/common/IconButton";
import {
  toggleEnableCronJob,
  toggleOpenBug,
} from "../management/redux/managementSlice";
import { StatusIcon } from "../../constants/icon_path";
import { showErrorToast } from "../../components/common/CustomErrorMessage";
import { useQueryCurrentUser } from "../../graphql/apollo/query-hooks";

const Settings = () => {
  const { currentUser } = useQueryCurrentUser();
  const dispatch = useDispatch();
  const { isBugOpen, isEnableCrobJob } = useSelector(
    (state) => state.management
  );
  const { data: { fetchSettings } = {} } = useQuery(FETCH_SETTINGS, {
    fetchPolicy: "network-only",
    onCompleted(data) {
      if (data.fetchSettings) {
        dispatch(toggleOpenBug(fetchSettings?.isBugOpen));
        dispatch(toggleEnableCronJob(fetchSettings?.isEnableCrobJob));
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [openBug] = useMutation(OPEN_BUG, {
    variables: { status: isBugOpen },
    refetchQueries: [{ query: FETCH_SETTINGS }],
    onCompleted: (data) => {
      if (data.openBug) {
        toast.success(
          `${data.openBug?.isBugOpen ? "ເປີດບັກ" : "ປີດບັກ"} ສຳເລັດແລ້ວ`,
          {
            position: "top-center",
            className: "lao",
          }
        );
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [activateCronjob] = useMutation(ACTIVATE_CRONJOB, {
    variables: { status: isEnableCrobJob },
    refetchQueries: [{ query: FETCH_SETTINGS }],
    onCompleted: (data) => {
      if (data.activateCronjob) {
        toast.success(
          `${
            data.activateCronjob?.isEnableCrobJob
              ? "ເປີດລະບົບເກມ"
              : "ປີດລະບົບເກມ"
          } ສຳເລັດແລ້ວ`,
          {
            position: "top-center",
            autoClose: 3000,
            className: "lao",
          }
        );
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [genSecretCode] = useMutation(GENERATE_NEW_CODE, {
    refetchQueries: [{ query: FETCH_SETTINGS }],
    onCompleted: (data) => {
      if (data.genSecretCode) {
        toast.success(`ສຳເລັດແລ້ວ`, {
          position: "top-center",
          autoClose: 3000,
          className: "lao",
        });
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handlechangeBug = (e) => dispatch(toggleOpenBug(e.target.checked));
  const handlechangeCronJob = (e) =>
    dispatch(toggleEnableCronJob(e.target.checked));
  const handleGenerateNewCode = () => genSecretCode();

  return (
    <div className="lao">
      <ListGroup>
        <ListGroup.Item>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <h4 className="pt-4">ເປີດ/ປິດບັກ</h4>
              <div className="p-2 m-1">
                <Input
                  className="mt-3"
                  type="switch"
                  onChange={handlechangeBug}
                  checked={isBugOpen}
                />
              </div>
              <IconButton
                onClick={openBug}
                iconSize={20}
                iconColor="white"
                text="ບັນທຶກ"
                className="icon-btn"
              />
            </div>
            <div>
              <StatusIcon
                size={50}
                color={fetchSettings?.isBugOpen ? "green" : "red"}
              />
            </div>
          </div>
        </ListGroup.Item>
        <ListGroup.Item>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <h4 className="pt-4">ເປີດ/ປິດລະບົບເກມ</h4>
              <div className="p-2 m-1">
                <Input
                  className="mt-3"
                  type="switch"
                  onChange={handlechangeCronJob}
                  checked={isEnableCrobJob}
                />
              </div>
              <IconButton
                onClick={activateCronjob}
                iconSize={20}
                iconColor="white"
                text="ບັນທຶກ"
                className="icon-btn"
              />
            </div>
            <div>
              <StatusIcon
                size={50}
                color={fetchSettings?.isEnableCrobJob ? "green" : "red"}
              />
            </div>
          </div>
        </ListGroup.Item>
        {currentUser?.isSuperAdmin && (
          <ListGroup.Item style={{ display: "flex" }}>
            <h4 className="p-1">Secret Code</h4>
            <Alert className="py-1" variant="secondary">
              {fetchSettings?.secretCode}
            </Alert>
            <Button style={{ marginLeft: 10 }} onClick={handleGenerateNewCode}>
              ສ້າງ code ໃໝ່
            </Button>
          </ListGroup.Item>
        )}
      </ListGroup>
    </div>
  );
};

export default Settings;
